import React from 'react';
import { Button, Icon, Tag } from 'antd';
import Wrapper from '../../../../../common/component/Wrapper';
import MultiLanguageInput, { getDefaultTranslation } from '../MultiLanguageInput';
import './styles.less';

const padTime = (value) => `${value || 0}`.padStart(2, '0');

export const formatSessionTime = (session = {}) =>
    `${padTime(session.startHour)}:${padTime(session.startMinute)} - ${padTime(session.endHour)}:${padTime(session.endMinute)}`;

const SlotServices = (props) => {
    const { t, slotServices, onChange, isShowSync, onSync, isSyncing } = props;

    const onChangeSlotService = (index, translations) => {
        const newSlotServices = (slotServices || []).map((item, idx) => (
            idx === index ? { ...item, translations } : item
        ));
        onChange(newSlotServices);
    };

    return (
        <>
        <Wrapper className="slot-services">
            <label>{t('item.ratecode.slotServices')}</label>
            {(slotServices || []).map((slotService, index) => {
                const defaultTranslation = getDefaultTranslation(slotService.translations || []);
                return (
                    <Wrapper className="slot-services-item" key={slotService.id || index}>
                        <MultiLanguageInput
                            t={t}
                            value={defaultTranslation?.name}
                            translations={slotService.translations}
                            placeholder={t('item.ratecode.slotServices')}
                            onChange={(name, translations) => onChangeSlotService(index, translations)}
                        />
                        <Wrapper className="slot-services-item-sessions">
                            {(slotService.sessions || []).map((session, sessionIndex) => (
                                <Tag key={session.id || sessionIndex}>
                                    <Icon type="clock-circle" className="mr-1" />
                                    {formatSessionTime(session)}
                                </Tag>
                            ))}
                        </Wrapper>
                    </Wrapper>
                )
            })}

            {isShowSync && (
                <Wrapper className="slot-services">
                    <Wrapper>
                        <Button type="primary" loading={isSyncing} onClick={onSync}>
                            {t('item.ratecode.syncSlotServices')}
                        </Button>
                    </Wrapper>
                </Wrapper>
            )}
        </Wrapper>
        </>
    )
};

SlotServices.defaultProps = {
    slotServices: [],
    onChange: () => { },
};

export default SlotServices;
